import Grid from '@mui/material/Grid';
import type { JSX, ReactNode } from 'react';
import {
  StyledChildrenGrid,
  StyledContainerGrid,
  StyledExcludeItemsRemoveIcon,
  StyledExcludeItemsRemoveIconButton,
} from './styled/ExcludeItems.styled.tsx';
import { Title } from './Title.tsx';

type ExcludeItemsProps = {
  children: ReactNode;
  title: string;
};

export const ExcludeItems = ({ children, title }: ExcludeItemsProps): JSX.Element => {
  return (
    <StyledContainerGrid container sx={{ flexDirection: 'column' }}>
      <Title title={title} data-test="exclude-subset-allow" />
      <Grid
        container
        wrap="nowrap"
        sx={{
          alignItems: 'flex-start',
          marginTop: theme => theme.spacing(1),
        }}
      >
        <StyledExcludeItemsRemoveIconButton disabled size="large">
          <StyledExcludeItemsRemoveIcon size={20} />
        </StyledExcludeItemsRemoveIconButton>
        <StyledChildrenGrid>{children}</StyledChildrenGrid>
      </Grid>
    </StyledContainerGrid>
  );
};
